import React from "react";
import { isNullOrWhiteSpace } from "../functions/isNullOrWhiteSpace";

export const convertCssStringToCssProperties = (cssString: string | null | undefined): React.CSSProperties | undefined => {
    if (isNullOrWhiteSpace(cssString)) return undefined;

    cssString = cssString.replace(/ /g, "")
    
    return cssString.split(';').map(cur => cur.split(':')).reduce((acc, val) => {
        let [ key, value ] = val;
        key = key.replace(/-./g, css => css.toUpperCase()[1])
        acc[key] = value;
        return acc;
    }, {});
};
